import { TypeColumn } from "../common/enums/AllEnums";

export interface IForm {
    formularioID: number;
    departamentoGUID: string;
    usuarioModificoGUID: string | null;
    nombre: string;
    departamentoNombre?: string | null;
    esFormularioSecuencial: boolean;
    visualizacionTipo?: TypeVisualization;
    visualizacionTipoNombre: string | null;
    distancia: number;
    cantidadDiasHistorico: number;
    bloquearPaginacion: boolean;
    cantidadRegistro: number;
    cantidadMaximaLlenado: number;
    cantidadMaximaLlenadoDia: number;
    diaSemana: string;
    fechaDesde: string | null;
    fechaHasta: string | null;
    formularioEstadoTipo?: FormStatus;
    formularioEstadoTipoNombre: string | null;
    listadoNombre: string | null;
    bloquearListado: boolean;
    formularioDetalle: IFormDetail[] | null;
    formularioGrupoPregunta: IFormQuetionGroup[] | null;
    pregunta: IFormQuestion[] | null;
    mostrarListadoDisponible: boolean;
}

export enum TypeVisualization {
    Mapa = 1,
    Listado = 2,
    Tabla = 3,
    ListadoDetalle = 4
}

export enum FormStatus {
    Disponible = 1,
    NoDiponible = 2,
    Modificando = 3
}

export interface IFormDetail {
    formularioDetalleID: number;
    formularioID: number;
    nombre: string;
    detalleTipo: number;
    detalleTipoNombre: string | null;
    columnaTipo: TypeColumn;
    columnaTipoNombre: string | null;
    columnaValor: string | null;
    orden: number;
}

export interface IFormQuetionGroup {
    formularioGrupoPreguntaID: number;
    formularioID: number;
    grupoPreguntaID: number;
    grupoPreguntaNombre: string;
    orden: number;
}


export interface IFormQuestion {
    preguntaID: number;
    formularioID: number;
    formularioGrupoPreguntaID: number | null;
    grupoPreguntaID: number | null;
    pregunta: string;
    preguntaTipo: number | null;
    preguntaTipoNombre: string | null;
    esPrincipal: boolean;
    esObligatoria: boolean;
    valorMinimo: string | null;
    valorMaximo: string | null;
    orden: number;
    respuestaOpcionTipo: number;
    respuestaOpcionTipoNombre: string | null;
    query: string | null;
    frecuenciaActualizacionID: number | null;
    atributoNombre1: string | null;
    atributoValor1: string | null;
    atributoNombre2: string | null;
    atributoValor2: string | null;
    atributoNombre3: string | null;
    atributoValor3: string | null;
    respuestaOpcion: IFormQuestionOption[];
}

export interface IFormQuestionOption {
    respuestaOpcionID: number;
    preguntaID: number;
    preguntaSiguienteID: number | null;
    respuesta: string | null;
    resultado: string | null;
    orden: number;
}

export interface IFormRelated {
    formularioListadoID: number;
    formularioID: number;
    formularioNombre: string;
    listadoIDInicial: number | null;
    listadoID: number | null;
    listadoNombre: string;
    formularioListadoUsuario: IFormRelatedUser[];
}

export interface IFormRelatedUser {
    formularioListadoUsuarioID: number;
    formularioListadoID: number;
    grupoUsuarioID: number | null;
    usuarioGUID: string | null;
    departamentoGUID: string | null;
}   
